import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { FaUser, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';

const LoginPage = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      const response = await axios.post('https://gce.iasoft.ma/api/login', form);

      navigate('/clients');
    } catch (error) {
      setError(error.response?.data?.message || 'Erreur de connexion.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <form onSubmit={handleSubmit} style={styles.form}>
        <img src="/logo.png" alt="Logo" style={styles.logo} />
        <h2 style={styles.title}>Connexion</h2>

        <div style={styles.inputWrapper}>
          <FaUser style={styles.icon} />
          <input
            type="email"
            name="email"
            placeholder="Adresse email"
            required
            style={styles.input}
            onFocus={e => e.target.style.border = '2px solid black'}
            onBlur={e => e.target.style.border = '1px solid rgba(0,0,0,0.1)'}
            onChange={handleChange}
          />
        </div>

        <div style={styles.inputWrapper}>
          <FaLock style={styles.icon} />
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="Mot de passe"
            required
            style={styles.input}
            onFocus={e => e.target.style.border = '2px solid black'}
            onBlur={e => e.target.style.border = '1px solid rgba(0,0,0,0.1)'}
            onChange={handleChange}
          />
          <span
            style={styles.passwordToggle}
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        {error && <p style={styles.error}>{error}</p>}

        <button
          type="submit"
          style={styles.button}
          disabled={isLoading}
        >
          {isLoading ? 'Connexion en cours...' : 'Se connecter'}
        </button>

        <p style={styles.linkText}>
          Vous n'avez pas de compte ?
          <Link to="/register" style={styles.link}>Créer un compte</Link>
        </p>
      </form>
    </div>
  );
};

const styles = {
container: {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  backgroundImage: 'url("/image.avif")',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'fixed', // rend l'image fixe
  padding: '20px',
  width: '100%',
  fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif'
},



form: {
  background: 'rgba(255, 255, 255, 0.6)',
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  padding: '2.5rem',
  borderRadius: '15px',
  boxShadow: '0 15px 35px rgba(0, 0, 0, 0.2)',
  width: '100%',
  maxWidth: '450px'
},

  logo: {
    display: 'block',
    margin: '0 auto 1rem',
    maxWidth: '120px'
  },
  title: {
    textAlign: 'center',
    marginBottom: '2rem',
    color: '#2d3748',
    fontSize: '2rem',
    fontWeight: 600
  },
  inputWrapper: {
    position: 'relative',
    marginBottom: '1.5rem'
  },
  icon: {
    position: 'absolute',
    top: '50%',
    left: '15px',
    transform: 'translateY(-50%)',
    fontSize: '1rem',
    color: '#000',
    opacity: 0.8
  },
  input: {
    width: '100%',
    padding: '15px 15px 15px 45px',
    border: '1px solid rgba(0,0,0,0.1)',
    borderRadius: '8px',
    background: '#fff',
    fontSize: '1rem',
    color: '#4a5568',
    transition: 'border 0.3s ease',
    outline: 'none'
  },
  passwordToggle: {
    position: 'absolute',
    top: '50%',
    right: '15px',
    transform: 'translateY(-50%)',
    fontSize: '1rem',
    color: 'rgb(0, 0, 0)',
    cursor: 'pointer'
  },
  button: {
    width: '100%',
    padding: '15px',
    background: 'black',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '1rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'transform 0.2s',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
  },
  error: {
    color: '#e53e3e',
    fontSize: '0.9rem',
    marginBottom: '1rem',
    textAlign: 'center'
  },
  linkText: {
    textAlign: 'center',
    marginTop: '1.5rem',
    fontSize: '0.95rem',
    color: '#718096'
  },
  link: {
    color: '#000',
    textDecoration: 'none',
    fontWeight: 600,
    marginLeft: '5px'
  }
};

export default LoginPage;
